import moment from 'moment/moment';

export const reception_document = () => {
    return {
        id: -1,
        correlative_company: null,
        cufe: null,
        status: null,
        status_dian_code: null,
        status_dian_description: null,
        status_dian_date: null,
        status_name: null,
        issue_date: moment().format('YYYY-MM-DD'),
        due_date: moment().add('months', 1).format('YYYY-MM-DD'),
        reception_date: null,
        issue_time: null,
        total_value_brut: 0,
        iva: 0,
        rete_iva: 0,
        rete_fte: 0,
        rete_ica: 0,
        total_value: 0,
        total_amount: 0,
        document_number: null,
        identification_number: null,
        contact_id: null,
        business_name: null,
        document_type: null,
        issuer_type: null,
        identity_type: null,
        contact: {},
        referrals_ids: [],
        authorized: false
    };
};

export const accounting_document = () => {
    return {
        branch_office_id: null,
        voucher_type_id: null,
        prefix: null,
        consecutive: null,
        document_date: null,
        due_date: null,
        center_cost_id: null,
        observation: null,
        referrals_ids: [],
        affects_prefix_document: null,
        affects_number_document: null
    };
};

export const params_referrals = () => {
    return {
        branch_office_id: null,
        branch_office_warehouse_id: null,
        dates: [
            moment().add('month', -12).format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
        ],
        voucher_type_id: null,
        model_id: null,
        contact_id: null,
        state_id: 1,
        paginate: 1,
        per_page: 15,
        page: 1
    };
};

export default {
    reception_documents: [],
    reception_document: reception_document(),
    accounting_document: accounting_document(),
    params_concepts: {
        paginate: true,
        page: 1,
        perPage: 15,
        filter: '',
        ids: [],
    },
    preloader: false,
    branch_offices: [],
    voucher_types: [],
    params: {
        state_id: '01'
    },
    concepts: {data: []},
    subscriber: null,
    fiscal_responsibilities: [],
    accounts: [],
    modal_pdf: {
        show: false,
        url: null
    },
    modal_rejection: {
        show: false,
        url: null
    },
    support_document_mode: false,
    code_voucher_type: '320',
    code_voucher_type_referrals: null,
    contacts: [],
    mode_referrals: 0,
    show_left_panel: 1,
    referrals: {data: []},
    params_referrals: params_referrals(),
    cost_centers: [],
    rejection_reasons: [],
    contact_warehouse: null
};



// WEBPACK FOOTER //
// ./src/modules/reception_documents/state.js